import React from 'react';
import styles from './cookieConsent.module.css';
import { useLegalDoc } from '../../contexts/SiteConfigContext';

// Версия согласия: при изменении текста/политик увеличьте — баннер покажется снова.
const CONSENT_VERSION = '1';
const STORAGE_KEY = 'cookie_consent';

// Адреса берутся у активных версий документов; переменные окружения
// остаются запасным вариантом на случай, если документ ещё не заведён.
const PRIVACY_FALLBACK =
  process.env.REACT_APP_PRIVACY_URL ?? 'https://amazingrp.ru/files/personal-data-policy.pdf';
const TOS_FALLBACK =
  process.env.REACT_APP_COOKIE_POLICY_URL ?? 'https://amazingrp.ru/files/user-agreement.pdf';

/**
 * Информирование об использовании cookie и обработке персональных данных
 * (152-ФЗ). Явное активное согласие: баннер скрывается только после нажатия
 * «Принять», факт согласия фиксируется с версией и датой в localStorage.
 */
const CookieConsent: React.FC = () => {
  const [visible, setVisible] = React.useState(false);
  const privacy = useLegalDoc('privacy');
  const tos = useLegalDoc('tos');

  React.useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const accepted = raw ? (JSON.parse(raw) as { version?: string }).version === CONSENT_VERSION : false;
      setVisible(!accepted);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: CONSENT_VERSION, ts: new Date().toISOString() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="region" aria-label="Уведомление об использовании cookie">
      <span className={styles.icon} aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a4 4 0 0 0 5 5 4 4 0 0 0 4.8 4.8z" />
          <path d="M8.5 9.5h.01M12 15h.01M16 13h.01M8 14h.01" />
        </svg>
      </span>
      <p className={styles.text}>
        Мы используем файлы cookie и обрабатываем персональные данные для работы сайта,
        авторизации и аналитики. Нажимая «Принять», вы соглашаетесь с{' '}
        <a className={styles.link} href={privacy?.url ?? PRIVACY_FALLBACK} target="_blank" rel="noopener noreferrer">
          политикой конфиденциальности
        </a>{' '}
        и{' '}
        <a className={styles.link} href={tos?.url ?? TOS_FALLBACK} target="_blank" rel="noopener noreferrer">
          пользовательским соглашением
        </a>{' '}
        в соответствии с Федеральным законом № 152-ФЗ «О персональных данных».
      </p>
      <button type="button" className={styles.button} onClick={accept}>
        Принять
      </button>
    </div>
  );
};

export default CookieConsent;
